import React, { useRef, useState, useEffect } from 'react'

import { useParams, useHistory } from 'react-router-dom'

import { toast } from 'react-toastify'

import EditProfileImage from '../../../../../presentation/pages/common/edit-profile-image'

import { useMe } from '../../../../../presentation/contexts/me'

import { makeContractors } from '../../../../usecases/contractors/remote-contractors-factory'
import { makeDoctors } from '../../../../usecases/doctors/remote-doctors-factory'
import { makeUploadFile } from '../../../../usecases/upload-file/remote-upload-file-factory'

import LinkBuilder from '../../../../../presentation/helpers/helper-link-builder'

const MakeEditProfileImage = () => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const { userType } = useParams<{
    userType: string
  }>()

  const [image, setImage] = useState<File>()

  const [user, setUser] = useState<any>(null)

  const { me } = useMe()

  const history = useHistory()

  const urls = {
    editContractor: 'contractors/upload-file',
    editDoctor: 'doctor/upload-file',
    createContractor: 'public/register/contractor/upload-file',
    createDoctor: 'public/register/doctor/upload-file',
  }

  useEffect(() => {
    const loadUser = async () => {
      if (!me) return

      try {
        const data = userType === 'contractor'
          ? await makeContractors().loadById(me.id as number)
          : await makeDoctors().loadById(me.id as number)
        setUser(data)
      } catch (error) {
        console.error(error)
      }
    }

    loadUser()
  }, [me, userType])

  const handleFileInput = () => {
    fileInputRef.current?.click()
  }

  const handleImageSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0]

    if (!(file?.type === 'image/jpeg' || file?.type === 'image/png')) {
      toast.error(
        'O arquivo enviado não é uma imagem válida. Tente enviar uma imagem no formato JPEG ou PNG.',
      )
      return
    }

    if (file) {
      setImage(file)
    }
  }

  const determineUrlAndAction = (hasImage: boolean) => {
    let url

    if (userType === 'contractor') {
      url = hasImage ? urls.editContractor : urls.createContractor
    } else {
      url = hasImage ? urls.editDoctor : urls.createDoctor
    }

    const action = hasImage ? 'update' : 'post'

    return { url, action }
  }

  const handleSave = async () => {
    if (!image || !user) return

    const formData = new FormData()
    formData.append('file', image)
    formData.append('type', 'application/jpeg')

    const img = user.document.find((doc: any) => doc.url.startsWith('images/'))
    const hasImage = !!img
    const { url, action } = determineUrlAndAction(hasImage)

    if (!hasImage) {
      formData.append('email', user.email)
    }

    try {
      if (action === 'post') {
        await makeUploadFile(url).post(formData)
      } else {
        await makeUploadFile(url).update(img.id, user.id, formData)
      }
      history.goBack()
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  const getImageUrl = () => {
    if (image) {
      return URL.createObjectURL(image)
    }

    if (user) {
      const imageDoc = user.document.find((doc: any) => doc.url.startsWith('images/'))
      if (imageDoc) {
        return LinkBuilder.buildAssetsUrl(imageDoc.url)
      }
    }

    return ''
  }

  const imgUrl = getImageUrl()

  const props = {
    handleFileInput,
    handleImageSelect,
    handleSave,
    imgUrl,
  }

  return <EditProfileImage ref={fileInputRef} {...props} />
}

export default MakeEditProfileImage
